import { Stack } from '@mui/joy'
import Grid from '@mui/joy/Grid'
import Section from '../../Section/Section'
import { Heading, Paragraph } from '../../Text'
import { HeroBackground } from '../../Hero'

export default function Hero({ title, description, heroImage }) {
    return (
        <Section
            py={0}
            backdrop={
                <HeroBackground
                    ratio="662 / 376"
                    src={heroImage}
                    objectPosition="top"
                    style={{
                        minHeight: '40vh',
                    }}
                />
            }
        >
            <Grid
                container
                spacing={0}
                minHeight="40vh"
                height="calc(100vw / 662 * 376 / 2)"
                alignItems="center"
            >
                <Grid xs={12}>
                    <Stack
                        spacing={{
                            xs: 4,
                            sm: 8,
                        }}
                        sx={{
                            height: '100%',
                            justifyContent: 'center',
                        }}
                    >
                        <Heading
                            mt={0}
                            mb={0}
                            fontSize={{
                                xs: '2.5rem',
                                sm: '3rem',
                                md: '3.5rem',
                                lg: '4rem',
                            }}
                            color="#fff"
                            sx={{
                                whiteSpace: 'break-spaces',
                            }}
                        >
                            {title}
                        </Heading>
                        <Paragraph
                            fontSize={{
                                xs: '1.25rem',
                                sm: '1.5rem',
                            }}
                            color="#fff"
                            sx={{
                                whiteSpace: 'break-spaces',
                            }}
                            fontWeight={300}
                        >
                            {description}
                        </Paragraph>
                    </Stack>
                </Grid>
            </Grid>
        </Section>
    )
}
